import React from 'react'
import FoodSlide from '../components/food-slide/FoodSlide'
import { Link } from 'react-router-dom'
import { OutlineButton } from '../components/button/Button'
import FoodList from '../components/category-list/CategoryList'
import AreaList from '../components/area-list/AreaList';
import Alphabets from '../components/alphabets/Alphabets'

const Home = () => {
  return (
    <div>
      <FoodSlide />

      <div className="conatiner">
        <div className="section mb-3">
          <div className="section__header mb-3">
            <h2>Top Categories</h2>
            <Link to='/categories'>
              <OutlineButton className='small'>View All</OutlineButton>
            </Link>
          </div>
          <FoodList />
        </div>

        <div className="section mb-3">
          <div className="section__header mb-3">
            <h2>Top Areas</h2>
            <Link to='/areas'>
              <OutlineButton className='small'>View All</OutlineButton>
            </Link>
          </div>
          <AreaList />
        </div>

        <div className="section mb-3">
          <div className="section__header mb-3">
            <h2>Food by Letters</h2>
            <Link to='/alphabets'>
              <OutlineButton className='small'>View All</OutlineButton>
            </Link>
          </div>
          <Alphabets />
        </div>

      </div>
    </div>
  )
}

export default Home